import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { AppFilter } from '@app/shared/models';
import { CompanyOwnershipService } from '@app/shared/services/company-ownership.service';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
} from '@richardlt/ng2-semantic-ui';
import { tap } from 'rxjs/operators';
import { OrganizationService } from 'src/modules/features/admin/services';
import {
  DocumentTypeService,
  OptionService,
} from 'src/modules/features/setting/services';

interface IViewHistoryModalContext {
  title: string;
  organization: any;
  data?: any;
}
@Component({
  selector: 'app-view-non-network-assessment-modal',
  templateUrl: './view-non-network-assessment-modal.component.html',
  styleUrls: ['./view-non-network-component.scss'],
})
export class ViewNonNetworkAssessmentModalComponent implements OnInit {
  allPendingHistory;
  pendingHistory;
  success: any;
  error: any;
  pending: boolean;
  filter: AppFilter = new AppFilter();
  totalItems: number = 0;
  rows: number = 2;
  currentPage: number = 1;
  maxSize: number = 7;
  organizationId: string;
  allHistory: any = [];
  isPending: boolean = this.modal.context.data
    ? this.modal.context.data.isPending
    : false;
  isChecked: string;
  searchFilter = {
    groupOp: 'AND',
    rules: [
      {
        field: 'changeRequestType',
        op: 'cn',
        data: 'this.toEdit',
      },
    ],
  };
  collapseHistory = [];
  selectedRequest: any;
  detail: any;
  organizationAol;
  applications;
  searchOptionFilter = {
    groupOp: 'AND',
    rules: [
      {
        field: 'optionType.optionTypeId',
        op: 'eq',
        data: '',
      },
      {
        field: 'optionName',
        op: 'cn',
        data: '',
      },
    ],
  };
  searchYearFilter = {
    groupOp: 'AND',
    rules: [
      {
        field: 'jpaFinancialYear.year',
        op: 'eq',
        data: '',
      },
    ],
  };
  filterOption: AppFilter = new AppFilter({
    rows: 1000,
    sord: 'desc',
  });
  lookupTemplates;
  lookupNonTemplates;
  searchNonOptionFilter = {
    groupOp: 'AND',
    rules: [
      {
        field: 'optionType.optionTypeId',
        op: 'eq',
        data: '',
      },
      {
        field: 'optionName',
        op: 'cn',
        data: '',
      },
    ],
  };
  filterNonOption: AppFilter = new AppFilter({
    rows: 1000,
    sord: 'desc',
  });
  constructor(
    @Inject(DOCUMENT) private document,
    private fb: FormBuilder,
    private organizationSvc: OrganizationService,
    private documentTypeSvc: DocumentTypeService,
    public modal: SuiModal<IViewHistoryModalContext, void, void>,
    private companyOwnershipService: CompanyOwnershipService,
    private optionSvc: OptionService
  ) {
    this.searchNonOptionFilter.rules[0].data =
      'non_network_operator_license_type';
    this.getNonLicenseType(1);
    this.organizationAol = this.modal.context.organization;
    this.applications = this.modal.context.data;
    console.log(this.organizationAol, this.applications);
    this.filter = new AppFilter({ sidx: 'dateCreated', rows: 10 });
  }
  ngOnInit() {
    this.document.body.classList.remove('panel');
  }
  getNonLicenseType(page) {
    this.filterNonOption.page = page;
    this.pending = true;
    this.optionSvc.getPublicOption({ params: this.filterNonOption }).subscribe(
      (res: any) => {
        this.pending = false;
        this.lookupNonTemplates = res.rows;
        this.applications.map((item) => {
          const name = this.lookupNonTemplates.filter((id) => {
            return id.optionId === item.nonNetworkOperatorLicenseType;
          });
          item.nonNetworkOperatorLicenseType = name[0]?.optionName;
        });
      },
      (error) => {
        this.pending = false;
        this.error = error.error;
      }
    );
  }
  // s
  ngOnDestroy(): void {
    this.document.body.classList.add('panel');
  }
}

export class ViewNonNetworkAssessmentModal extends ComponentModalConfig<
  IViewHistoryModalContext,
  void,
  void
> {
  constructor(
    title: string,
    organization: any,
    data?: any,
    size: ModalSize = ModalSize.Large
  ) {
    super(ViewNonNetworkAssessmentModalComponent, {
      title,
      organization,
      data,
    });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
